'use strict';

var Backbone = require('backbone'),
  _ = require('underscore'),
  config = require('../../js/config'),
  mediator = require('../../js/mediator'),
  PointyModalView = require('../../js/components/PointyModalView'),
  ProjectEnvisionDesignModalView = require('./ProjectEnvisionDesignModalView'),
  ProjectDetailsEnvisionTooltip = Backbone.View.extend({

    initialize: function() {
      this.getState();
      this.initComponents();
      this.listenTo(this.envisionDesignView, ProjectEnvisionDesignModalView.EVENTS.confirmed, this.onConfirmed);
      this.listenTo(this.envisionDesignView, ProjectEnvisionDesignModalView.EVENTS.confirming, this.closePopup);
      this.listenTo(this.envisionDesignView, ProjectEnvisionDesignModalView.EVENTS.cancelled, this.closePopup);
    },

    events: {
      click: 'openEnvisionOptionsPopup'
    },

    getState: function() {
      this.hasDesign = this.$el.data('hasDesign');
      this.projectId = this.$el.data('projectId');
      this.pubId = this.$el.data('pubId');
      this.uri = this.$el.data('uri');
    },

    initComponents: function() {
      this.envisionDesignView = new ProjectEnvisionDesignModalView({
        hasDesign: this.hasDesign,
        projectId: this.projectId,
        pubId: this.pubId,
        uri: this.uri
      });
      this.envisionDesignView.render();
      this.pointy = new PointyModalView({
        el: this.el,
        position: 'left',
        contentCloning: false,
        content: this.envisionDesignView.$el
      });
    },

    onConfirmed: function() {
      // for some reason tooltipster doesn't calculate the position
      // correctly without this delay
      setTimeout(_.bind(function() {
        this.pointy.open();
      }, this), 500);
    },

    openEnvisionOptionsPopup: function(e) {
      if (e) e.preventDefault();
      this.pointy.open();
      mediator.on(config.events.ui.resize, this.closePopup, this);
    },

    closePopup: function() {
      this.pointy.close();
      mediator.off(config.events.ui.resize, this.closePopup);
    }

  }, {
    create: function($parent) {
      $parent.find('.js-projectDetailsEnvisionTrigger').each(function(n, el) {
        new ProjectDetailsEnvisionTooltip({
          el: el
        });
      });
    }
  });

module.exports = ProjectDetailsEnvisionTooltip;



// WEBPACK FOOTER //
// ./assets/components/DesignCenter/projectDetailsEnvisionTooltip.js